import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import PortfolioImg from "../../assets/images/portfolio.png";
import Pagination from "../ui/Pagination";
import EnSearchBar from "../ui/EnSearchBar";
import "../../styles/banner.css";
import { getListBoardPortfolio } from "../../api";

const Banner = ({ backgroundImage, title, description }) => {
  return (
    <div className="page-banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="banner-content">
        <h1>{title}</h1>
        {typeof description === "string" ? <p>{description}</p> : Array.isArray(description) ? description.map((line, index) => <p key={index}>{line}</p>) : null}
      </div>
    </div>
  );
};

const EnPortfolio = () => {
  const navigate = useNavigate();

  // Pagination 시작
  const [currentPage, setCurrentPage] = useState(1);
  const [displayedPortfolios, setDisplayedPortfolios] = useState([]);
  const portfoliosPerPage = 12;
  const [dataCount, setDataCount] = useState(1);
  // Pagination 끝

  // 검색바
  // const [originalPortfolios, setOriginalPortfolios] = useState([]);
  // const [filteredPortfolios, setFilteredPortfolios] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // 언어 설정
  const currentLang = "en";

  // 초기 로드 시 모든 시공사례 설정
  useEffect(() => {
    (async () => {
      const res = await getListBoardPortfolio({
        category: "시공",
        page: currentPage,
        search: searchTerm.trim() || undefined,
        lang: currentLang,
      });
      const data = res.data.results;
      setDataCount(res.data.count);
      setDisplayedPortfolios(data);
    })();
  }, [currentPage, searchTerm]);

  // 페이지 변경 시 표시할 시공사례 업데이트
  // useEffect(() => {
  //   const indexOfLastPortfolio = currentPage * portfoliosPerPage;
  //   const indexOfFirstPortfolio = indexOfLastPortfolio - portfoliosPerPage;
  //   setDisplayedPortfolios(filteredPortfolios.slice(indexOfFirstPortfolio, indexOfLastPortfolio));
  // }, [currentPage, filteredPortfolios]);

  // 검색어에 따라 시공사례 필터링
  useEffect(() => {
    // if (searchTerm.trim() === "") {
    // setFilteredPortfolios(originalPortfolios);
    // } else {
    //   const filtered = originalPortfolios.filter(
    //     (portfolio) =>
    //       portfolio.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //       portfolio.category.toLowerCase().includes(searchTerm.toLowerCase())
    //   );
    //   setFilteredPortfolios(filtered);
    // }
    setCurrentPage(1);
  }, [searchTerm]);

  const handlePortfolioClick = (id) => {
    navigate(`/en/portfolio/${id}/`);
  };

  const handlePageChange = (pageNumber) => {
    const target = Math.max(1, Math.min(pageNumber, totalPages));
    setCurrentPage((prev) => (prev === target ? prev : target));
    window.scrollTo({
      top: document.querySelector(".portfolio-section").offsetTop - 100,
      behavior: "smooth",
    });
  };

  const handleSearch = (term) => {
    setCurrentPage(1);
    setSearchTerm(term);
  };

  const totalPages = Math.ceil((dataCount ?? 0) / portfoliosPerPage);
  const bannerDescription = [
    "ECOTECH GLOBAL releases sound from the field with technology.",
    "With a design tailored to the reality of the farmhouse and thorough construction quality, it provides a reliable greenhouse environment.",
  ];
  return (
    <div className="portfolio-container">
      <Banner backgroundImage={PortfolioImg} title="Construction case" description={bannerDescription} />
      <div className="portfolio-content">
        <div className="portfolio-description">
          <h2>Construction case</h2>
          <p>
            Glass greenhouse construction, glass replacement, screen installation, motor repair and replacement, fire greenhouse multiple,
            <br />
            Total greenhouse construction and maintenance are underway, such as installing light shielding films and construction of floating fans.
          </p>
        </div>
        <div className="portfolio-section">
          <div className="portfolio-info">
            <p>{dataCount} items</p>
            <EnSearchBar onSearch={handleSearch} />
          </div>
          <hr />

          {displayedPortfolios && displayedPortfolios.length > 0 ? (
            <div className="portfolio-grid">
              {displayedPortfolios.map((portfolio) => (
                <div
                  key={portfolio.id}
                  className="portfolio-box"
                  onClick={() => handlePortfolioClick(portfolio.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handlePortfolioClick(portfolio.id);
                    }
                  }}
                >
                  <div className="portfolio-thumbnail-container">
                    <img src={`${portfolio.thumbnail.file.url}`} alt={portfolio.title} className="portfolio-thumbnail" />
                    <div className="hover-overlay">
                      <span className="detail-text">View Details</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" className="arrownew-icon">
                        <g data-name="그룹 62">
                          <g data-name="그룹 61">
                            <path
                              data-name="패스 44"
                              d="M9118.341 1662.063h23.6"
                              transform="translate(-9101.257 -1633.028)"
                              style={{ strokeLinecap: "round", stroke: "#fff", strokeWidth: "2px", fill: "none" }}
                            />
                            <path
                              data-name="패스 45"
                              d="m9187.706 1640.815 5.992 5.993-5.992 5.992"
                              transform="translate(-9153.012 -1617.773)"
                              style={{ strokeLinejoin: "round", strokeLinecap: "round", stroke: "#fff", strokeWidth: "2px", fill: "none" }}
                            />
                          </g>
                          <g data-name="타원 1" style={{ stroke: "#fff", strokeWidth: "2px", fill: "none" }}>
                            <circle cx="29" cy="29" r="29" style={{ stroke: "none" }} />
                            <circle cx="29" cy="29" r="28" style={{ fill: "none" }} />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="portfolio-title">
                    <span className="portfolio-category">{portfolio.portfolio_en_category || "Construction Work"}</span>
                    <h3>{portfolio.en_translations[0]?.title_en || portfolio.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>There is no items.</p>
            </div>
          )}
          {totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />}
        </div>
      </div>
    </div>
  );
};

export default EnPortfolio;
